import { useFormikContext } from "formik";
import Typography from "@mui/material/Typography";
import { CreateCampaignData } from "../../../types/campaign";
import TextField from "@mui/material/TextField";
import { Autocomplete } from "../../Autocomplete";
import Stack from "@mui/material/Stack";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { DAYS, FREQUENCY, MONTH_DAYS } from "../../../utils/constants";
import { TimePicker } from "../../TimePicker";
import { useMemo } from "react";

export function Automation() {
  const formik = useFormikContext<CreateCampaignData>();

  const whenSendOptions = useMemo(() => {
    return formik.values.intervalFrequency?.value !== "months"
      ? DAYS
      : MONTH_DAYS;
  }, [formik.values.intervalFrequency]);

  const showWhenSendOptions = useMemo(() => {
    return (
      formik.values.intervalFrequency &&
      formik.values.intervalFrequency?.value !== "days"
    );
  }, [formik.values.intervalFrequency]);

  return (
    <Stack spacing={4}>
      <FormControlLabel
        checked={formik.values.isAutomation}
        onChange={(_, checked) => {
          formik.setFieldValue("isAutomation", checked);
        }}
        control={<Checkbox />}
        label={<Typography color="primary">Automação</Typography>}
      />
      <TextField
        disabled={!formik.values.isAutomation}
        type="number"
        label="Intervalo"
        autoFocus
        onChange={({ target: { value } }) =>
          formik.setFieldValue("intervalAutomation", value)
        }
        fullWidth
        size="small"
        value={formik.values.intervalAutomation}
        InputProps={{
          inputProps: {
            min: 0,
          },
        }}
        error={!!formik.errors.intervalAutomation}
        helperText={
          !!formik.errors.intervalAutomation && formik.errors.intervalAutomation
        }
      />
      <Autocomplete
        disabled={!formik.values.isAutomation}
        size="small"
        label="Frequência"
        options={FREQUENCY}
        getOptionLabel={(option) => option.label}
        onChange={(_, option) =>
          formik.setFieldValue("intervalFrequency", option)
        }
        value={formik.values.intervalFrequency}
        error={!!formik.errors.intervalFrequency}
        helperText={
          !!formik.errors.intervalFrequency &&
          (formik.errors.intervalFrequency as string)
        }
      />
      {showWhenSendOptions && (
        <Autocomplete
          disabled={!formik.values.isAutomation}
          size="small"
          label="Quando enviar"
          options={whenSendOptions}
          getOptionLabel={(option) => option.label}
          onChange={(_, option) =>
            formik.setFieldValue("whenSendAutomation", option)
          }
          value={formik.values.whenSendAutomation}
          error={!!formik.errors.whenSendAutomation}
          helperText={
            !!formik.errors.whenSendAutomation &&
            (formik.errors.whenSendAutomation as string)
          }
        />
      )}
      <TimePicker
        disabled={!formik.values.isAutomation}
        fullWidth
        size="small"
        label="Horário"
        value={formik.values.intervalHour}
        onChange={(date) => formik.setFieldValue("intervalHour", date)}
        error={!!formik.errors.intervalHour}
        helperText={
          !!formik.errors.intervalHour && (formik.errors.intervalHour as string)
        }
      />
    </Stack>
  );
}
